export const getLang = (locale: string = 'en'): string => locale.split('-')[0];
